import * as autoLayoutFetcher from './auto_layout_fetcher';
import * as autocompleteFetcher from './autocomplete_fetcher';
import * as caseFetcher from './case_fetcher';
import * as dashboardFetcher from './dashboard_fetcher';
import * as documentFetcher from './document_fetcher';
import * as fileFetcher from './file_fetcher';
import * as filterFetcher from './filter_fetcher';
import * as hierarchyFetcher from './hierarchy_fetcher';
import * as searchDataFetcher from './search_data_fetcher';

export {
  autocompleteFetcher,
  autoLayoutFetcher,
  caseFetcher,
  dashboardFetcher,
  documentFetcher,
  fileFetcher,
  filterFetcher,
  hierarchyFetcher,
  searchDataFetcher,
};
export default {
  autocompleteFetcher,
  autoLayoutFetcher,
  caseFetcher,
  dashboardFetcher,
  documentFetcher,
  fileFetcher,
  filterFetcher,
  hierarchyFetcher,
  searchDataFetcher,
};
